module.exports = __webpack_public_path__ + "img/model-notice.0567cce5.png";